
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
// intl messages
import IntlMessages from 'Util/IntlMessages'; 
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';

// app config
import AppConfig from 'Constants/AppConfig';

import {
   Card,
   CardTitle
} from 'reactstrap';

import {

  allStudents
} from 'Actions';


class CommonDashboard extends Component {

  constructor(props) {
     
     super(props);
     this.state = {
        academydiv:false,
        sudentdiv:true,
         
     };      
      
     
      //this.onBackSection = this.onBackSection.bind(this);  
 }

  UNSAFE_componentWillMount() {
   
     this.props.allStudents();
  }

   render() {
      const { match } = this.props;
      const { studentlists, loading } = this.props;

      const styles = {
        maindiv: {             
            cursor: "pointer",
            hover:{
              backgroundColor: "salmon",
              color: "white"
            }
        }
        
      };
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Dashboard | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.saas" />} match={match} />
           
            {this.state.sudentdiv &&
                <div className="col-md-12">
                    <div className="dddd">
                        <a href="/app/contract/contractdashboard"><button class="mr-10 mb-10 btn btn-info">Contract Dashboard</button></a>
                    </div>
                </div>
            } 
        </div>
      )
   }
}

const mapStateToProps = ({ mostlyused }) => {
  
   const { studentlists, loading } = mostlyused;
   return { studentlists, loading };
}

export default connect(mapStateToProps, {
 
  allStudents
})(CommonDashboard); 
